'use client';

import type { MouseEvent} from 'react';
import { useState } from 'react';

import { copyToClipboard } from '@ui/uikit/utils/copy';

import { cn } from '../../../../utils';
import { Copy } from '../../../icons/mono/Copy';
import { Typography } from '../../Typography';
import styles from './CopyLinkControl.module.scss';

interface CopyLinkControlProps {
  shareUrl?: string;
}

const CopyLinkControl = ({ shareUrl }: CopyLinkControlProps) => {
  const [visibleText, setVisibleText] = useState<'copy' | 'copied'>('copy');
  const [isVisible, setIsVisible] = useState(true);

  const handleCopyLinkControlClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();

    if (shareUrl) {
      copyToClipboard(shareUrl).then(() => {
        setIsVisible(false);

        setTimeout(() => {
          setVisibleText('copied');
          setIsVisible(true);

          setTimeout(() => {
            setIsVisible(false);

            setTimeout(() => {
              setVisibleText('copy');
              setIsVisible(true);
            }, 150);
          }, 3000);
        }, 150);
      });
    }
  };

  return (
    <div onClick={handleCopyLinkControlClick} className="tooltip-container">
      <Copy className="tooltip-icon" />
      <span
        className={cn(styles['tooltip-text'], {
          [styles['fade-in']]: isVisible,
          [styles['fade-out']]: !isVisible,
        })}
      >
        <Typography variant="caption-s-strong" color="primary">
          {visibleText === 'copy' ? 'Copy Link' : 'Copied!'}
        </Typography>
      </span>
    </div>
  );
};

export { CopyLinkControl };
